const COOKIE_NAME = "compaws_user_type";
const MAX_AGE = 60 * 60; // 1 hour

export function setUserTypeCookie(userType: "humano" | "compawdre") {
  document.cookie = `${COOKIE_NAME}=${userType};path=/;max-age=${MAX_AGE};SameSite=Lax`;
}

export function getUserTypeCookie(): "humano" | "compawdre" | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=(humano|compawdre)`));
  return match ? (match[1] as "humano" | "compawdre") : null;
}

export function clearUserTypeCookie() {
  document.cookie = `${COOKIE_NAME}=;path=/;max-age=0`;
}
